<template>
  <div>
    <div class="aedw-package-buttons">
      <template v-for="(item, key) in categories">
        <button
          :key="key"
          class="m-1 btn"
          :class="{ 
              'btn-primary': isSelected(item), 
              'btn-outline-primary': !isSelected(item) 
            }"
          @click="onSelect(item)"
        >{{ item.tagline || item.name }}</button>
      </template>
    </div>

    <PackageList
      :useCustomTemplate="useCustomTemplate"
      :templateName="templateName"
      :params="mergedParams"
      :config="config"
      :useDefaultGridCols="useDefaultGridCols"
      :disableGetPackagesOnRender="disableGetPackagesOnRender"
      :show_in_carroussel_mobile="show_in_carroussel_mobile"
      :show_in_carroussel_desktop="show_in_carroussel_desktop"
      :titleWidget="titleWidget"
      :use_location_unit_selector="use_location_unit_selector"
      :location_unit_selector_params="location_unit_selector_params"
      :use_multi_widgets="use_multi_widgets"
      :multi_widgets_params="multi_widgets_params"
      :paramsFilterRequestPOS="paramsFilterRequestPOS"
    />
  </div>
</template>

<style lang="scss">
.aedw-package-buttons {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 25px;
}
</style>

<script>
import PackageList from "./package-list.vue";

export default {
  components: { PackageList },

  props: [
    "categories",
    "useCustomTemplate",
    "templateName",
    "config",
    "useDefaultGridCols",
    "params",
    "disableGetPackagesOnRender",
    "show_in_carroussel_mobile",
    "show_in_carroussel_desktop",
    "titleWidget",
    "use_location_unit_selector",
    "location_unit_selector_params",
    "use_multi_widgets",
    "multi_widgets_params",
    "paramsFilterRequestPOS"
  ],

  data() {
    return {
      categorySelected: null,
      mergedParams: {},
    };
  },

  created() {
    this.mergedParams = { ...this.params };
  },
  mounted(){

  },
  methods: {
    isSelected(item) {
      return (
        Boolean(this.categorySelected) && this.categorySelected.id === item.id
      );
    },
    onSelect(item) {
      this.mergedParams = {
        ...this.mergedParams,
        category_list: item.id,
      };

      this.categorySelected = item;
    },
  },
};
</script>